export enum EmployeeState {
  Accepted = "Accepted",
  Pending = "Pending",
  TriedButFailed = "TriedButFailed",
  EnrollmentInProcess = "EnrollmentInProcess",
  EnrollmentInQueue = "EnrollmentInQueue",
  PayrollEnrolled = "PayrollEnrolled",
  KYCDataCompleted = "KYCDataCompleted",
  KYCDataPending = "KYCDataPending",
  KYCFailed = "KYCFailed",
  // Wizard step progress
  TermsAccepted = "TermsAccepted",
  BeneficiaryAdded = "BeneficiaryAdded",
  GoalAdded = "GoalAdded",
  ContributionSet = "ContributionSet",
  InvestmentOptionAdded = "InvestmentOptionAdded",

  // Additional Data
  AdditionalDataCompleted = "Completed",
  PendingWithHR = "PendingWithHR",
  ReadyForAccountOpening = "ReadyForAccountOpening",
  AccountOpened = "AccountOpened",
  AccountRejected = "AccountRejected",
}

export const ENROLLED_STATUSES: EmployeeState[] = [
  EmployeeState.Accepted,
  EmployeeState.KYCDataPending,
  EmployeeState.KYCDataCompleted,
  EmployeeState.AccountOpened,
  EmployeeState.AdditionalDataCompleted,
];

export enum OnboardingProgressState {
  TermsAccepted = "TermsAccepted",
  BeneficiaryAdded = "BeneficiaryAdded",
  GoalAdded = "GoalAdded",
  ContributionSet = "ContributionSet",
  InvestmentOptionAdded = "InvestmentOptionAdded",
  Onboarding1Completed = "Onboarding1Completed",
  BeneficiaryDetailsComplete = "BeneficiaryDetailsComplete",
  SchoolInfoComplete = "SchoolInfoComplete",
  SuccessorInfoComplete = "SuccessorInfoComplete",
  BankInfoComplete = "BankInfoComplete",
  Onboarding2Completed = "Onboarding2Completed",
}

export const ONBOARDINGPROCESS_STATUSES: OnboardingProgressState[] = [
  OnboardingProgressState.Onboarding1Completed,
  OnboardingProgressState.BeneficiaryDetailsComplete,
  OnboardingProgressState.SchoolInfoComplete,
  OnboardingProgressState.SuccessorInfoComplete,
  OnboardingProgressState.BankInfoComplete,
  OnboardingProgressState.Onboarding2Completed,
];

export const isEnrolledStatus = (status: string): boolean =>
  ENROLLED_STATUSES.includes(status as EmployeeState);

export const isBoardingProcessingStatue = (status: string): boolean =>
  ONBOARDINGPROCESS_STATUSES.includes(status as OnboardingProgressState);
